import type { ComponentProps } from 'react';

import {
  Dialog,
  DialogContent,
  DialogDescription,
  DialogHeader,
  DialogTitle,
} from '@/components/ui/dialog';
import { ReviewForm } from '../forms/review-form';
import type { AttorneyOption, EditableReviewRow, ReviewFormMode } from '../types';

export function ReviewFormDialog({
  attorneys,
  mode,
  review,
  open,
  onOpenChange,
  onSuccess,
  onCloseAutoFocus,
  formOptions,
}: {
  attorneys: AttorneyOption[];
  mode: ReviewFormMode;
  review?: EditableReviewRow | null;
  open: boolean;
  onOpenChange: (open: boolean) => void;
  onSuccess?: () => void;
  onCloseAutoFocus?: (event: Event) => void;
  formOptions?: ComponentProps<typeof ReviewForm>['options'];
}) {
  const isEdit = mode === 'edit';

  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent size="lg" onCloseAutoFocus={onCloseAutoFocus}>
        <DialogHeader>
          <DialogTitle>{isEdit ? 'Edit Review' : 'Add Review'}</DialogTitle>
          <DialogDescription>
            {isEdit
              ? 'Update review details before publishing it on your site.'
              : 'Enter review details to manually publish it on your site.'}
          </DialogDescription>
        </DialogHeader>

        {open && isEdit && review ? (
          <ReviewForm
            key={review.id}
            options={formOptions}
            attorneys={attorneys}
            mode="edit"
            review={review}
            onOpenChange={onOpenChange}
            onSuccess={onSuccess}
          />
        ) : open && !isEdit ? (
          <ReviewForm
            options={formOptions}
            attorneys={attorneys}
            mode="create"
            onOpenChange={onOpenChange}
            onSuccess={onSuccess}
          />
        ) : null}
      </DialogContent>
    </Dialog>
  );
}
